module.exports = new __parcel__URL__("app-preview-dark.692f3794.svg").toString();